import { render, staticRenderFns } from "./NewLibraryModal.vue?vue&type=template&id=4ceca6db&lang=pug&"
import script from "./NewLibraryModal.vue?vue&type=script&lang=js&"
export * from "./NewLibraryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports